import React from 'react';
import portfolio from '../../data/portfolio';
import ProjectVisual from '../work/ProjectVisual';
import styles from './ExperimentGrid.module.css';

export default function ExperimentGrid({ items = portfolio.experiments }) {
  return (
    <section id="experiments" className={styles.section} aria-labelledby="experiments-title">
      <div className="section-heading">
        <h2 id="experiments-title">Compact explorations</h2>
        <p>
          Smaller builds and research probes where I test one idea at a time — a{' '}
          <strong>VLA fine-tune</strong>, a <strong>robot-learning study</strong>, and personal
          automation infrastructure. All of it is current work.
        </p>
      </div>

      <div className={styles.entries}>
        {items.map((item) => {
          const source = item.sourceRecord;
          const github = source?.github || source?.links?.github || '';
          const description = source?.description || source?.summary || item.label;
          const status = `${item.status.charAt(0).toUpperCase()}${item.status.slice(1)}`;

          return (
            <article className={styles.entry} data-experiment-entry key={item.id}>
              <div className={styles.entryHeader}>
                <h3>
                  {github ? (
                    <a href={github} target="_blank" rel="noreferrer">
                      {item.title}
                    </a>
                  ) : (
                    item.title
                  )}
                </h3>
                <span>
                  {item.label} · {status}
                </span>
              </div>
              <p className={styles.description}>{description}</p>
              {source?.tech ? <p className={styles.tech}>{source.tech}</p> : null}
              <ProjectVisual media={item.media} />
            </article>
          );
        })}
      </div>
    </section>
  );
}
